import { useEffect } from 'react';
import { useAxios } from 'src/hooks/use-axios';
import { AssignmentWithDocumentsResponse } from 'src/pages/operators/assignments/overview/types';
import urltemplate from 'url-template';

type Options = {
  userId: string;
  tsoId: string;
};

export function useGetAssignmentWithDocuments({ userId, tsoId }: Options) {
  const assignments = useAxios(
    (axios, signal) =>
      axios.request<AssignmentWithDocumentsResponse>({
        signal,
        url: urltemplate
          .parse(
            `${PRISMA_CONFIG.oldBackendUrl}/shipperUsers/{userId}/assignments/{tsoId}`
          )
          .expand({ userId, tsoId }),
        method: 'GET',
      }),
    { neededOnPageLoad: false }
  );

  useEffect(() => {
    assignments.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return assignments;
}

export type GetAssignmentWithDocumentsRequest = ReturnType<
  typeof useGetAssignmentWithDocuments
>;
